var DataPortsServiceModule = /** @class */ (function () {
    function DataPortsServiceModule() {
    }
    return DataPortsServiceModule;
}());
export { DataPortsServiceModule };
